import { PublicReviewErrorDto } from "@swagger/typescript-fetch-goflyer";
import { messages } from "../../../locales/messages";
import { toastError } from "../../../utils/pageUtil/toast";
import { ReviewErrorCode } from "./types";

const codeToMessage: Partial<
  Record<ReviewErrorCode, () => [string, ...unknown[]]>
> = {
  AUDIENCE_KEY_TAKEN: messages.Audience_Key_Already_Taken,
  [PublicReviewErrorDto.CodeEnum.EDITREQUIRED]: messages.Edit_Permission_Required,
  [PublicReviewErrorDto.CodeEnum.FIELDNOTYETSUPPORTED]:
    messages.Field_Not_Yet_Supported,
  [PublicReviewErrorDto.CodeEnum.FLYERALREADYAPPROVED]:
    messages.Flyer_Already_Approved,
  [PublicReviewErrorDto.CodeEnum.TOKENEXPIRED]: messages.Token_Expired,
  [PublicReviewErrorDto.CodeEnum.TOKENREVOKED]: messages.Token_Revoked,
  [PublicReviewErrorDto.CodeEnum.AUDIENCEREVOKED]: messages.Audience_Revoked,
  [PublicReviewErrorDto.CodeEnum.SESSIONCLOSED]: messages.Session_Closed,
};

export async function extractReviewError(
  error: unknown,
): Promise<{ code?: ReviewErrorCode; message?: string }> {
  if (!error) return {};
  const anyErr = error as { json?: () => Promise<unknown> };
  if (typeof anyErr.json === "function") {
    try {
      const body = (await anyErr.json()) as {
        code?: string;
        errorCode?: string;
        message?: string;
      };
      const raw = body?.code || body?.errorCode;
      return {
        code: raw as ReviewErrorCode | undefined,
        message: body?.message,
      };
    } catch {
      return {};
    }
  }
  return {};
}

export async function handleReviewError(
  error: unknown,
  t: (k: any) => string,
  fallbackMessage?: string,
): Promise<ReviewErrorCode | undefined> {
  const { code, message } = await extractReviewError(error);
  const mapped = code ? codeToMessage[code as ReviewErrorCode] : undefined;
  if (code && mapped) {
    toastError(t(mapped()));
    return code as ReviewErrorCode;
  }
  toastError(
    message ||
      fallbackMessage ||
      t(messages.There_is_an_error_please_Contact_Administrator()),
  );
  return code as ReviewErrorCode | undefined;
}
